import { PaymentHistoryRow, PaymentMethodCard } from '@/entities/payment'
import { PlanBenefitsList, PlanPriceCard } from '@/entities/plan'
import type { CatalogComponentEntry } from './component-registry.types'

export const entitiesRegistryEntries: CatalogComponentEntry[] = [
  {
    name: 'PlanPriceCard',
    path: 'entities/plan/ui/plan-price-card',
    layer: 'entities',
    description: 'Selectable plan price card (single selection state).',
    component: PlanPriceCard,
    render: () => (
      <div className="grid gap-3 md:grid-cols-2">
        <PlanPriceCard
          duration="6 месяцев"
          price="2 490 ₽"
          pricePerMonth="415 ₽ / мес"
          trailingLabel="выгоднее на 20%"
          selected
        />
        <PlanPriceCard duration="1 месяц" price="1 490 ₽" showPricePerMonth={false} />
      </div>
    ),
  },
  {
    name: 'PlanBenefitsList',
    path: 'entities/plan/ui/plan-benefits-list',
    layer: 'entities',
    description: 'Subscription benefits list (paid variation).',
    component: PlanBenefitsList,
    render: () => <PlanBenefitsList />,
  },
  {
    name: 'PaymentMethodCard',
    path: 'entities/payment/ui/payment-method-card',
    layer: 'entities',
    description: 'Selectable payment method cards (CloudPayment, Долями).',
    component: PaymentMethodCard,
    render: () => (
      <div className="flex flex-wrap gap-3">
        <PaymentMethodCard variant="cloud-payment" />
        <PaymentMethodCard variant="cloud-payment" selected />
        <PaymentMethodCard variant="dolami" />
        <PaymentMethodCard variant="dolami" selected />
      </div>
    ),
  },
  {
    name: 'PaymentHistoryRow',
    path: 'entities/payment/ui/payment-history-row',
    layer: 'entities',
    description: 'History row with status, date, plan name, and amount (desktop).',
    component: PaymentHistoryRow,
    render: () => (
      <div className="flex flex-col gap-3">
        <PaymentHistoryRow
          status="success"
          date="26.12.25"
          planName="Тариф — 12 месяцев"
          amount="30 000 ₽"
          variant="desktop"
        />
        <PaymentHistoryRow
          status="declined"
          date="15.01.26"
          planName="Тариф — 1 месяц"
          amount="1 490 ₽"
          variant="desktop"
        />
      </div>
    ),
  },
  {
    name: 'PaymentHistoryRow / mobile',
    path: 'entities/payment/ui/payment-history-row',
    layer: 'entities',
    description: 'History row with status icon and mobile layout.',
    component: PaymentHistoryRow,
    render: () => (
      <div className="flex w-full flex-col gap-3">
        <PaymentHistoryRow
          status="success"
          date="04.12.2024"
          planName="Тариф — 3 месяца"
          amount="10 000 ₽"
          variant="mobile"
        />
        <PaymentHistoryRow
          status="declined"
          date="01.12.2024"
          planName="Тариф — 3 месяца"
          amount="10 000 ₽"
          variant="mobile"
        />
      </div>
    ),
  },
]
